import type { CompileResult } from "../runtime-types";
import { useIndicatorLoggerStore } from "./logger-store";

/** Push Roslyn / runtime compile lines into the editor Output tab. */
export function appendCompileLogsToBuild(result: CompileResult): void {
  const logger = useIndicatorLoggerStore.getState();
  for (const line of result.logs ?? []) {
    if (line.trim().length > 0) logger.appendBuild(line);
  }
}
